<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
// Keep the <html> lang and dir attributes in sync with the active locale.
// dir comes from each locale's config in nuxt.config.ts (ar is dir: 'rtl'),
// so right-to-left locales like Arabic render correctly.
const i18nHead = useLocaleHead({ addDirAttribute: true, addSeoAttributes: false });

useHead(() => ({
  htmlAttrs: {
    dir: i18nHead.value.htmlAttrs?.dir ?? 'ltr',
    lang: i18nHead.value.htmlAttrs?.lang ?? 'en',
  },
}));
</script>
